import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import {
  NetworkService,
  NetworkStatus,
} from '@services/common-functions/network.service';
import { LocalStorage } from '@services/local-storage/local-storage';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, MatTooltipModule, MatIconModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  userInfo: any;
  roleId: any;
  roleName: any;
  hidehamburger: boolean = false;
  routePrefix: string = '/rd-manager'; // default
  network!: NetworkStatus;
  constructor(
    private readonly router: Router,
    private readonly _localStorageService: LocalStorage,
    private _networkService: NetworkService
  ) {
    this.userInfo = JSON.parse(this._localStorageService.getUser());
    this.roleId = this.userInfo.role[0].roleId;
    this.roleName = this.userInfo.role[0].roleName;
    this._networkService.network$.subscribe((n) => (this.network = n));
  }

  ngOnInit() {
    if (this.roleName === 'RD Manager') {
      this.routePrefix = '/rd-manager';
    } else if (this.roleName === 'Admin') {
      this.routePrefix = '/admin';
    } else if (this.roleName === 'Management') {
      this.routePrefix = '/management';
    } else if (this.roleName === 'OD Manager') {
      this.routePrefix = '/od-manager';
    } else if (this.roleName === 'Storekeeper') {
      this.routePrefix = '/storekeeper';
    } else if (this.roleName === 'HR') {
      this.routePrefix = '/hr-manager';
    } else if (this.roleName === 'Interviewer') {
      this.routePrefix = '/interviewer';
    } else if (this.roleName === 'QC Officer') {
      this.routePrefix = '/qc-officer';
    } else if (this.roleName === 'Supervisor') {
      this.routePrefix = '/supervisor';
    } else if (
      this.roleName === 'Scripter' ||
      this.roleName === 'Data Cleaner' ||
      this.roleName === 'Data Processor'
    ) {
      this.routePrefix = '/scripter';
    } else if (this.roleName === 'CATI Agent') {
      this.routePrefix = '/cati';
    } else if (this.roleName === 'Data Checker') {
      this.routePrefix = '/data-checker';
    } else if (this.roleName === 'Finance') {
      this.routePrefix = '/finance';
    }
  }
}
